module.exports = __webpack_public_path__ + "img/img5_9.789e30fc.jpeg";